<template>
  <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0 mt-2">
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img :src="avatarSrc" class="c-avatar-img" style="height: 100%" />
        </div>
      </CHeaderNavLink>
    </template>

    <CDropdownItem @click="logout">
      <CIcon name="cil-AccountLogout" size="md" class="mr-2" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getItem, setItem } from "@/utils/db";
import router from "@/router";

export default {
  name: "TheHeaderDropdownAccnt",

  computed: {
    ...mapGetters("Auth", ["selectedUser"]),

    avatarSrc() {
      const img = this.selectedUser?.userinfo?.image;
      return img ? img : require("@/assets/avatars/1.jpg");
    },
  },

  methods: {
    ...mapActions("Auth", ["signOut"]),

    async logout() {
      try {
        const objs = await getItem("objs");
        if (!objs?.xAccessToken) return;

        await this.signOut({ xAccessToken: objs.xAccessToken });
        await setItem("objs", null);
        router.push({ name: "Login" });
      } catch (err) {
        console.error("Logout error:", err);
      }
    },
  },

  async mounted() {
    const objs = await getItem("objs");
    if (!objs?.xAccessToken) return;

    // โหลด users จาก store หรือ IndexedDB
    let users = this.$store.getters["Auth/fetchUsers"];
    if (!users || users.length === 0) {
      users = (await getItem("users")) || [];
      this.$store.commit("Auth/fetchUsers", users);
    }

    // หา user ที่ตรงกับ token
    const currentUser = users.find((u) =>
      u.control?.device?.some((d) => d.xAccessToken === objs.xAccessToken)
    );

    if (currentUser) {
      // ✅ ใช้ full user object
      this.$store.commit("Auth/setSelectedUser", currentUser);
    }

    console.log("SelectedUser:", this.selectedUser);
  },
};
</script>
